import { ReloadRequiredDialog } from '@components/common/molecules';
import { isWebsocketErrorAtom } from '@data/common/webSocket/states';
import { useAtomValue } from 'jotai';

const WebsocketErrorDialog: React.FC = () => {
  const isWebsocketError = useAtomValue(isWebsocketErrorAtom);

  return (
    <ReloadRequiredDialog
      isOpen={isWebsocketError}
      title={'dialog.websocket_error.title'}
      message={'dialog.websocket_error.message'}
    />
  );
};

export default WebsocketErrorDialog;
